import { OptionType } from '@/typings/common';

import { ServiceDealersInitialTab } from './types';

export const serviceDealersTabsData: OptionType<ServiceDealersInitialTab>[] = [
  { label: 'Список', value: 'list' },
  { label: 'Карта', value: 'map' },
];
